import React from 'react';

import { AxisTickProps } from '@nivo/axes';

export const CustomBottomTick = (tick: AxisTickProps<string>) => {
  return <g transform={`translate(${tick.x},${tick.y + 16})`} />;
};
